import { SceneManager } from './SceneManager';
import { CoreController } from '../CoreController';

export class Translator {
    private static _instance: Translator;
    private translations: any[];
    private userLanguage: string;

    constructor() {
        this.translations = SceneManager.getInstance().getJson('translation');
        this.userLanguage = CoreController.getInstance().getManager().getUserLanguage();
        // this.userLanguage = 'RO';
    }

    public static getInstance(): Translator {
        return this._instance || (this._instance = new this());
    }

    public getTranslation(key: string): string {
        let result: string;
        this.translations.forEach((translation: any): void => {
            if (translation.EN === key) {
                if (translation[this.userLanguage]) {
                    result = translation[this.userLanguage];
                }
            }
        });
        if (!result) {
            result = key;
            console.log('MISSING TRANSLATION ' + key + ' FOR LANGUAGE ' + this.userLanguage);
        }
        return result;
    }
}